// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"7913a13a","435":"c86d4ecf","787":"8d0a538e","834":"6c0f1ab2"}[chunkId] + ".chunk.js";
};